module.exports = __webpack_public_path__ + "static/media/iphones-black-setup-image.6a2b1e22.png";